<template>
  <a :href="href">{{ text }}</a>
</template>

<script>
export default {
  props: {
    type: { type: String, required: true },
    name: { type: String, required: true },
  },
  computed: {
    entry() {
      try {
        return this.$store.getters['flow/contacts'][this.type][this.name] || {};
      } catch (e) {
        return {};
      }
    },
    href() {
      return this.entry.link || '';
    },
    text() {
      return this.entry.displayed || '';
    },
  },
};
</script>

<style lang="scss" scoped>
a {
  white-space: nowrap;
}
</style>
